import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const Unavailable = ({ onSync, syncing }: { onSync: () => void; syncing: boolean }) => {
  return (
    <>
      <Box gap="s4" flexDirection="row">
        <Icon.Medium icon="alert-circle-line" color="radicalRed1000" />
        <Text.Header2>
          {i18n.t('payroll_integrations.incidences.datev_lauds.personal_data.unavailable.title')}
        </Text.Header2>
      </Box>
      <Box>
        {i18n.t('payroll_integrations.incidences.datev_lauds.personal_data.unavailable.message')}
      </Box>
      <Button onClick={onSync} disabled={syncing}>
        {i18n.t('payroll_integrations.incidences.datev_lauds.personal_data.unavailable.submit')}
      </Button>
    </>
  )
}

export default Unavailable
